// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1891":"e00f57f2","6952":"e00f57f2","9555":"e00f57f2","9744":"adf88a18"}[chunkId] + ".chunk.css";
};